module.exports = __webpack_public_path__ + "img/mail.08e4e888.svg";